<template>
  <slot></slot>
</template>

<script setup lang="ts">
declare global {
  interface Window {
    _aiden: any
    _aidenApp: any
  }
}

const scriptId = 'aiden-script'
const { initiatedThirdParty } = useApp()

watch(initiatedThirdParty, () => {
  initScript()
})

function initScript() {
  if (!initiatedThirdParty.value) {
    return
  }

  if (!document?.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.async = true
    script.id = scriptId

    script.src = `https://app.aiden.cx/webshop/build/aiden-embedded.min.js`

    document.body.appendChild(script)
  }
}

function destroyAiden() {
  document?.getElementById(scriptId)?.remove()

  if (window._aiden) {
    delete window._aiden
  }

  if (window._aidenApp) {
    delete window._aidenApp
  }
}

onMounted(() => {
  initScript()
})

onUnmounted(() => {
  destroyAiden()
})
</script>
